import { Component, Inject, OnInit } from '@angular/core';
import { ConfigServiceInterface } from '../../../../core/services/config/config-service.interface';
import { AuthServiceInterface } from '../../../../core/services/auth/auth-service.interface';
import { UserResponse } from '../../../../core/services/auth/responses/user.response';
import { DOCUMENT } from '@angular/common';
import { BrowserWindowRef } from '../../../../core/services/window/window.service';

@Component({
  selector: 'gtd-authorized-component',
  templateUrl: './authorized.component.html',
})
export class AuthorizedComponent implements OnInit {
  public user: UserResponse;

  constructor(
    @Inject('ConfigServiceInterface') public configService: ConfigServiceInterface,
    @Inject('AuthServiceInterface') private authService: AuthServiceInterface,
    @Inject(DOCUMENT) private document: Document,
    private window: BrowserWindowRef
  ) {
    this.user = this.authService.getUserData();
  }

  ngOnInit(): void {
    if (this.user.id) {
      this.initFrontAppChat();
    }
  }

  logout() {
    this.authService.logout();
  }

  private initFrontAppChat(): void {
    const userData = this.authService.getUserData();
    if (userData && userData.chat_variables) {
      const userId = userData.chat_variables.front_app_master_id;
      const userHash = userData.chat_variables.front_app_hash;
      if (userId && userHash && this.configService.frontAppChatId) {
        const script = this.document.createElement('script');
        script.src = 'https://chat-assets.frontapp.com/v1/chat.bundle.js';
        const user = this.authService.getUserData();
        script.onload = () => {
          this.window.nativeWindow.FrontChat?.('init', {
            chatId: this.configService.frontAppChatId,
            useDefaultLauncher: true,
            userId: userId,
            userHash: userHash,
            name: `${user.fname ?? ''} ${user.lname ?? ''}`.trim(),
            contact: {
              email: user.email,
            },
          });
        };
        this.document.body.appendChild(script);
      }
    }
  }
}
